const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";


class EnvironmentUtils {
    static isBirdApp() {
        return IS_BIRD_APP;
    }

    static isSddApp() {
        return !IS_BIRD_APP;
    }
}

export default EnvironmentUtils;